import { createSearchIdByTime, SEARCH_ID_APP_NAME } from '@lmn/lmn-commonlogic/dist/utils';
import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';

type UpdatePlatformSearchIdProps = {
  searchParams: SearchParams;
  userUid: string;
  isApp: boolean;
};

export const createPlatformSearchId = (userId: string): string =>
  createSearchIdByTime(SEARCH_ID_APP_NAME.TSX, getUIDPrefixFourChars(userId));

export const getUIDPrefixFourChars = (id: string): string => (id.length >= 4 ? id.slice(0, 4) : 'xxxx');

export const createPlatformSearchIdFromPreClickId = (userIdFourChars: string): string =>
  createSearchIdByTime(SEARCH_ID_APP_NAME.TSX, userIdFourChars);

export const getUpdatedSearchId = ({
  userUid,
  isApp,
  searchParams,
}: {
  userUid: string;
  isApp: boolean;
  searchParams: SearchParams;
}) => {
  const searchId = searchParams?.[URLParameters.SEARCH_ID] || '';
  return searchId
    ? updatePlatformSearchId({ searchParams, userUid: userUid || '', isApp })
    : createPlatformSearchId(userUid || '');
};

const updatePlatformSearchId = ({ searchParams, userUid, isApp }: UpdatePlatformSearchIdProps): string => {
  const searchId = searchParams[URLParameters.SEARCH_ID];
  if (!searchId || searchId.length < 4) return createPlatformSearchId(userUid);
  // For the App View - If the first search has a searchId then just use it, don't change it.
  if (isApp) return searchId;
  return `${searchId.slice(0, -4)}${getUIDPrefixFourChars(userUid)}`;
};
